export function dateSorter(a, b) {
  if (new Date(a.date).getTime() < new Date(b.date).getTime()) {
    return 1;
  }

  if (new Date(a.date).getTime() > new Date(b.date).getTime()) {
    return -1;
  }

  return 0;
}



// WEBPACK FOOTER //
// ./src/services/dateSorter.js